const prefix = 'experience-sampling';

export default {
    update: `${prefix}.update`,
};



// WEBPACK FOOTER //
// ./scripts/frontend/base/actions/ExperienceSampling.js